import React from 'react';
import { Typography } from '@mui/material';
import { LibraryBooksRounded } from '@mui/icons-material';
import MateriaCard, { AddMateriaCard, MateriaCardSkeleton } from './MateriaCard';
import { IDocenteMateria } from '../../types/miRecurso';
import { PageContainer, HubGrid, HubEmptyState, ChangesNotice } from './styles';

const SKELETON_COUNT = 3;

interface MisRecursosPageProps {
	materias: IDocenteMateria[];
	isLoading: boolean;
	onSelectMateria: (materia: IDocenteMateria) => void;
	onAgregarMateria: () => void;
}

const MisRecursosPage: React.FC<MisRecursosPageProps> = ({
	materias,
	isLoading,
	onSelectMateria,
	onAgregarMateria,
}) => {
	if (isLoading) {
		return (
			<PageContainer>
				<HubGrid>
					{Array.from({ length: SKELETON_COUNT }).map((_, i) => (
						<MateriaCardSkeleton key={i} />
					))}
				</HubGrid>
			</PageContainer>
		);
	}

	if (materias.length === 0) {
		return (
			<PageContainer>
				<HubEmptyState>
					<LibraryBooksRounded
						style={{ fontSize: '4rem', opacity: 0.2, marginBottom: 12 }}
						color='action'
					/>
					<Typography variant='h6' color='text.secondary' gutterBottom>
						Aún no tienes materias registradas
					</Typography>
					<Typography variant='body2' color='text.secondary'>
						Agrega tu primera materia para comenzar a subir recursos.
					</Typography>
				</HubEmptyState>
				<HubGrid>
					<AddMateriaCard onClick={onAgregarMateria} />
				</HubGrid>
			</PageContainer>
		);
	}

	const hasChangesRequested = materias.some((materia) => materia.hasChangesRequested);

	return (
		<PageContainer>
			{hasChangesRequested && (
				<ChangesNotice variant='body2'>Hay materias con cambios solicitados.</ChangesNotice>
			)}
			<HubGrid>
				{materias.map((materia, index) => (
					<MateriaCard
						key={materia.id}
						materia={materia}
						colorIndex={index}
						onSelect={() => onSelectMateria(materia)}
					/>
				))}
				<AddMateriaCard onClick={onAgregarMateria} />
			</HubGrid>
		</PageContainer>
	);
};

export default MisRecursosPage;
